import { DeviceIdClient } from "commonModule/services/client"
import { defaultAxiosInstance } from "services/client"

export const apiDeviceIdClient = new DeviceIdClient(defaultAxiosInstance)
